module.exports = __webpack_public_path__ + "img/enterprise_banner2_2.25eee283.png";